import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { CleanDatePipe } from './clean-date.pipe';

@Pipe({
    name: 'age'
})
export class AgePipe implements PipeTransform {
    transform(value: any, args?: any): string {
        let today = moment();

        let birthdate = moment(value);
        let years = today.diff(birthdate, 'years');
        return '(' + years.toString() + ')';
    }
}
